import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMessengerComponent } from './simple-icons-messenger.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMessengerComponent ],
    exports:      [ SimpleIconsMessengerComponent ],
    bootstrap:    []
})
export class SimpleIconsMessengerModule {}
